module.exports = __webpack_public_path__ + "img/open-all-year.2.e94e770.jpg";